const formFields = [
  {
    name: "Group 1",
    order: 1,
    fields: [
      {
        fieldType: "text",
        order: 1,
      },
      {
        fieldType: "selection",
        order: 2,
      },
      {
        fieldType: "checkbox",
        order: 3,
      },
      {
        fieldType: "image/photo",
        order: 4,
      },
      {
        fieldType: "signature",
        order: 5,
      },
      {
        fieldType: "title",
        order: 6,
      },
      {
        fieldType: "staticImage",
        order: 7,
      },
      {
        fieldType: "staticDocument",
        order: 8,
      },
      {
        fieldType: "number",
        order: 8,
      },
      {
        fieldType: "date/time",
        order: 9,
      },
      {
        fieldType: "link",
        order: 10,
      },
    ],
  },
  {
    name: "Group 2",
    order: 2,
    fields: [
      {
        fieldType: "calculation",
        order: 1,
      },
      {
        fieldType: "increment",
        order: 2,
      },
      {
        fieldType: "barcode",
        order: 3,
      },
    ],
  },
  {
    name: "Group 3",
    order: 3,
    fields: [
      {
        fieldType: "rating",
        order: 1,
      },
      {
        fieldType: "slider",
        order: 2,
      },
      {
        fieldType: "gps",
        order: 3,
      },
    ],
  },
];

export const formFieldInputs = {
  text: [
    {
      name: "field_label",
      type: "textarea",
      label: "field_label",
      required: true,
      order: 1,
      defaultValue: "",
    },
    {
      name: "field_code",
      type: "text",
      label: "field_code",
      required: true,
      order: 2,
      defaultValue: "text_",
    },
    {
      name: "default_value",
      type: "text",
      label: "default_value",
      required: true,
      order: 3,
      defaultValue: "",
    },
    {
      name: "min_characters",
      type: "number",
      label: "min_chars",
      required: true,
      order: 4,
      defaultValue: null,
    },
    {
      name: "max_characters",
      type: "number",
      label: "max_chars",
      required: true,
      order: 5,
      defaultValue: null,
    },
    {
      name: "required",
      type: "checkbox",
      label: "required",
      required: true,
      order: 6,
      defaultValue: false,
    },
    {
      name: "read_only",
      type: "checkbox",
      label: "read_only",
      required: true,
      order: 7,
      defaultValue: false,
    },
    {
      name: "type",
      type: "checkbox",
      label: "editor",
      required: false,
      order: 8,
      defaultValue: false,
    },
    {
      name: "take_from_reference_data",
      type: "checkbox",
      label: "take_from_ref_data",
      required: true,
      order: 9,
      defaultValue: false,
    },
    {
      name: "regex",
      type: "text",
      label: "regex",
      required: true,
      order: 10,
      defaultValue: "",
    },
  ],
  selection: [
    {
      name: "field_label",
      type: "textarea",
      label: "field_label",
      required: true,
      order: 1,
      defaultValue: "",
    },
    {
      name: "field_code",
      type: "text",
      label: "field_code",
      required: true,
      order: 2,
      defaultValue: "selection_",
    },
    {
      name: "type",
      type: "selection",
      label: "type",
      required: true,
      order: 3,
      options: [
        {
          label: "form_templates.template_structure.selection.single_selection",
          value: "single_selection",
        },
        {
          label: "form_templates.template_structure.selection.multi_selection",
          value: "multi_selection",
        },
      ],
      defaultOption: "single_selection",
    },
    {
      name: "data_source",
      type: "selection",
      label: "data_source",
      required: true,
      order: 4,
      options: [
        {
          label: "form_templates.template_structure.selection.enter_manually",
          value: "enter_manually",
        },
        {
          label:
            "form_templates.template_structure.selection.from_reference_file",
          value: "from_reference_file",
        },
        {
          label:
            "form_templates.template_structure.selection.from_cascading_set",
          value: "from_cascading_set",
        },
      ],
      defaultOption: "enter_manually",
    },
    {
      name: "reference_data_source",
      type: "file",
      label: "reference_data_source",
      required: true,
      order: 5,
      with: "data_source:from_reference_file",
      action: "upload:reference_data_source",
    },
    {
      name: "reference_column",
      type: "selection",
      label: "reference_column",
      required: true,
      order: 6,
      options: [],
      with: "data_source:from_reference_file",
    },
    {
      name: "default_value",
      type: "text",
      label: "default_value",
      required: true,
      order: 8,
    },
    {
      name: "values",
      type: "array.text",
      label: "values",
      defaultValues: [],
      required: true,
      order: 7,
      defaultValue: [],
      with: "data_source:enter_manually",
    },
    {
      name: "required",
      type: "checkbox",
      label: "required",
      required: true,
      order: 9,
      defaultValue: false,
    },
    {
      name: "take_from_reference_data",
      type: "checkbox",
      label: "take_from_ref_data",
      required: true,
      order: 10,
    },
  ],
  checkbox: [
    {
      name: "field_label",
      type: "textarea",
      label: "field_label",
      required: true,
      order: 1,
      defaultValue: "",
    },
    {
      name: "field_code",
      type: "text",
      label: "field_code",
      required: true,
      order: 2,
      defaultValue: "checkbox_",
    },
    {
      name: "type",
      type: "selection",
      label: "style",
      required: true,
      order: 3,
      options: [
        {
          value: "checkbox",
          label: "checkbox",
        },
        {
          value: "radio_button",
          label: "radio",
        },
        {
          value: "button",
          label: "button",
        },
      ],
      defaultOption: "checkbox",
    },
    {
      name: "layout",
      type: "selection",
      label: "layout",
      required: true,
      order: 4,
      options: [
        {
          label: "horizontal",
          value: "horizontal",
        },
        {
          label: "vertical",
          value: "vertical",
        },
      ],
      defaultOption: "horizontal",
    },
    {
      name: "column_count",
      type: "number",
      label: "column_count",
      required: false,
      order: 5,
      defaultValue: null,
      with: "layout:vertical",
    },
    {
      name: "data_source",
      type: "text",
      label: "data_source",
      required: true,
      order: 6,
      defaultValue: "enter_manually",
      isReadOnly: true,
    },
    {
      name: "values",
      type: "array.text",
      label: "values",
      defaultValues: [],
      required: true,
      order: 7,
    },
    {
      name: "required",
      type: "checkbox",
      label: "required",
      required: true,
      order: 8,
      defaultValue: false,
    },
    {
      name: "take_from_reference_data",
      type: "checkbox",
      label: "take_from_ref_data",
      required: true,
      order: 9,
      defaultValue: false,
    },
  ],
  "image/photo": [
    {
      name: "field_label",
      type: "textarea",
      label: "field_label",
      required: true,
      order: 1,
      defaultValue: "",
    },
    {
      name: "field_code",
      type: "text",
      label: "field_code",
      required: true,
      order: 2,
      defaultValue: "image_",
    },
    {
      name: "type",
      type: "selection",
      label: "type",
      required: true,
      order: 3,
      options: [
        {
          label: "form_templates.template_structure.image_photo.single",
          value: "single",
        },
        {
          label: "form_templates.template_structure.image_photo.multiple",
          value: "multiple",
        },
      ],
      defaultOption: "single",
    },
    {
      name: "allow_drawing_on_photo",
      type: "checkbox",
      label: "allow_drawing_on_photos",
      required: true,
      order: 4,
      defaultValue: false,
    },
    {
      name: "allow_choosing_from_gallery",
      type: "checkbox",
      label: "allow_choosing_from_gallery",
      required: true,
      order: 5,
      defaultValue: false,
    },
    {
      name: "required",
      type: "checkbox",
      label: "required",
      required: true,
      order: 6,
      defaultValue: false,
    },
  ],
  signature: [
    {
      name: "field_label",
      type: "textarea",
      label: "field_label",
      required: true,
      order: 1,
      defaultValue: "",
    },
    {
      name: "field_code",
      type: "text",
      label: "field_code",
      required: true,
      order: 2,
      defaultValue: "signature_",
    },
    {
      name: "required",
      type: "checkbox",
      label: "required",
      required: true,
      order: 3,
      defaultValue: false,
    },
  ],
  title: [
    {
      name: "field_label",
      type: "textarea",
      label: "field_label",
      required: true,
      order: 1,
      defaultValue: "",
    },
    {
      name: "field_code",
      type: "text",
      label: "field_code",
      required: true,
      order: 2,
      defaultValue: "title_",
    },
  ],
  link: [
    {
      name: "field_label",
      type: "textarea",
      label: "field_label",
      required: true,
      order: 1,
      defaultValue: "",
    },
    {
      name: "field_code",
      type: "text",
      label: "field_code",
      required: true,
      order: 2,
      defaultValue: "link_",
    },
    {
      name: "style",
      type: "selection",
      label: "style",
      required: true,
      order: 3,
      options: [
        {
          label: "link",
          value: "link",
        },
        {
          label: "button",
          value: "button",
        },
      ],
      defaultOption: "link",
    },
    {
      name: "button_label",
      type: "text",
      label: "button_label",
      required: true,
      order: 4,
      defaultValue: "",
      with: "style:button",
    },
    {
      name: "url",
      type: "text",
      label: "url",
      required: true,
      order: 5,
      defaultValue: "",
    },
    {
      name: "take_from_reference_data",
      type: "checkbox",
      label: "take_from_ref_data",
      required: true,
      order: 6,
      defaultValue: false,
    },
  ],
  number: [
    {
      name: "field_label",
      type: "textarea",
      label: "field_label",
      required: true,
      order: 1,
      defaultValue: "",
    },
    {
      name: "field_code",
      type: "text",
      label: "field_code",
      required: true,
      order: 2,
      defaultValue: "number_",
    },
    {
      name: "style",
      type: "selection",
      label: "style",
      required: true,
      order: 3,
      options: [
        {
          label: "number",
          value: "number",
        },
        {
          label: "currency",
          value: "currency",
        },
      ],
      defaultOption: "number",
    },
    {
      name: "number_of_decimal_places",
      type: "selection",
      label: "number_of_decimal_places",
      allowZero: true,
      required: true,
      order: 5,
      options: [
        {
          label: "1",
          value: 0,
          isStaticValue: true,
        },
        {
          label: "1.0",
          value: 1,
          isStaticValue: true,
        },
        {
          label: "1.00",
          value: 2,
          isStaticValue: true,
        },
        {
          label: "1.000",
          value: 3,
          isStaticValue: true,
        },
        {
          label: "1.0000",
          value: 4,
          isStaticValue: true,
        },
      ],
      defaultOption: 0,
    },
    {
      name: "default_value",
      type: "number",
      label: "default_value",
      required: true,
      order: 6,
      defaultValue: null,
    },
    {
      name: "min_value",
      type: "number",
      label: "min_value",
      required: true,
      order: 7,
      defaultValue: null,
    },
    {
      name: "max_value",
      type: "number",
      label: "max_value",
      required: true,
      order: 8,
      defaultValue: null,
    },
    {
      name: "currency",
      type: "selection",
      label: "currency",
      required: true,
      order: 4,
      options: [
        {
          value: "€",
          label: "€",
          isStaticValue: true,
        },
        {
          value: "$",
          label: "$",
          isStaticValue: true,
        },
        {
          value: "£",
          label: "£",
          isStaticValue: true,
        },
        {
          value: "₺",
          label: "₺",
          isStaticValue: true,
        },
        {
          value: "₽",
          label: "₽",
          isStaticValue: true,
        },
        {
          value: "¥",
          label: "¥",
          isStaticValue: true,
        },
      ],
      defaultOption: "eur",
      with: "style:currency",
    },
    {
      name: "required",
      type: "checkbox",
      label: "required",
      required: true,
      order: 9,
      defaultValue: false,
    },
    {
      name: "read_only",
      type: "checkbox",
      label: "read_only",
      required: true,
      order: 10,
      defaultValue: false,
    },
    {
      name: "take_from_reference_data",
      type: "checkbox",
      label: "take_from_ref_data",
      required: true,
      order: 11,
      defaultValue: false,
    },
  ],
  staticDocument: [
    {
      name: "field_label",
      type: "textarea",
      label: "field_label",
      required: true,
      order: 1,
      defaultValue: "",
    },
    {
      name: "field_code",
      type: "text",
      label: "field_code",
      required: true,
      order: 2,
      defaultValue: "doc_",
    },
    {
      name: "file",
      type: "file",
      label: "file",
      required: true,
      order: 3,
    },
    {
      name: "button_label",
      type: "text",
      label: "button_label",
      required: true,
      order: 4,
      defaultValue: "",
    },
  ],
  staticImage: [
    {
      name: "field_label",
      type: "textarea",
      label: "field_label",
      required: true,
      order: 1,
      defaultValue: "",
    },
    {
      name: "field_code",
      type: "text",
      label: "field_code",
      required: true,
      order: 2,
      defaultValue: "static_",
    },
    {
      name: "image",
      type: "image",
      label: "image",
      required: true,
      order: 3,
    },
  ],
  "date/time": [
    {
      name: "field_label",
      type: "textarea",
      label: "field_label",
      required: true,
      order: 1,
      defaultValue: "",
    },
    {
      name: "field_code",
      type: "text",
      label: "field_code",
      required: true,
      order: 2,
      defaultValue: "date_",
    },
    {
      name: "type",
      type: "selection",
      label: "type",
      required: true,
      order: 3,
      options: [
        {
          label: "form_templates.template_structure.date_time.full_date",
          value: "DD/MM/YY",
          format: "dd/MM/yyyy",
        },
        {
          label:
            "form_templates.template_structure.date_time.only_month_and_year",
          value: "MM/YY",
          format: "MM/yyyy",
        },
        {
          label: "form_templates.template_structure.date_time.only_year",
          value: "YY",
          format: "yyyy",
        },
        {
          label: "form_templates.template_structure.date_time.only_time",
          value: "HH:MM:SS",
          format: "HH:mm",
        },
        {
          label:
            "form_templates.template_structure.date_time.full_date_and_time",
          value: "DD/MM/YY HH:MM:SS",
          format: "dd/MM/yyyy HH:mm",
        },
      ],
      defaultOption: "DD/MM/YY",
    },
    {
      name: "default_value",
      type: "date",
      label: "default_value",
      required: true,
      order: 4,
      defaultValue: null,
      format: "input:type",
    },
    {
      name: "min_value",
      type: "date",
      label: "min_value",
      required: true,
      order: 5,
      defaultValue: null,
      format: "input:type",
    },
    {
      name: "max_value",
      type: "date",
      label: "max_value",
      required: true,
      order: 6,
      defaultValue: null,
      format: "input:type",
    },
    {
      name: "required",
      type: "checkbox",
      label: "required",
      required: true,
      order: 7,
      defaultValue: false,
    },
    {
      name: "read_only",
      type: "checkbox",
      label: "read_only",
      required: true,
      order: 8,
      defaultValue: false,
    },
    {
      name: "take_from_reference_data",
      type: "checkbox",
      label: "take_from_ref_data",
      required: true,
      order: 9,
      defaultValue: false,
    },
  ],
  increment: [
    {
      name: "field_label",
      type: "textarea",
      label: "field_label",
      required: true,
      order: 1,
      defaultValue: "",
    },
    {
      name: "field_code",
      type: "text",
      label: "field_code",
      required: true,
      order: 2,
      defaultValue: "increment_",
    },
    {
      name: "default_value",
      type: "text",
      label: "default_value",
      required: true,
      order: 3,
      defaultValue: "",
    },
    {
      name: "min_value",
      type: "number",
      label: "min_value",
      required: true,
      order: 4,
      defaultValue: null,
    },
    {
      name: "max_value",
      type: "number",
      label: "max_value",
      required: true,
      order: 5,
      defaultValue: null,
    },
    {
      name: "required",
      type: "checkbox",
      label: "required",
      required: true,
      order: 6,
      defaultValue: false,
    },
    {
      name: "read_only",
      type: "checkbox",
      label: "read_only",
      required: true,
      order: 7,
      defaultValue: false,
    },
  ],
  calculation: [
    {
      name: "field_label",
      type: "textarea",
      label: "field_label",
      required: true,
      order: 1,
      defaultValue: "",
    },
    {
      name: "field_code",
      type: "text",
      label: "field_code",
      required: true,
      order: 2,
      defaultValue: "calculation_",
    },
    {
      name: "detail",
      type: "special.calculation",
      label: "Detail",
      required: true,
      order: 3,
      fields: [
        {
          name: "output",
          type: "text",
          label: "output",
          required: true,
          order: 1,
        },
        {
          name: "currency",
          type: "text",
          label: "currency",
          required: true,
          order: 2,
        },
        {
          name: "number_of_decimal_places",
          type: "selection",
          label: "number_of_decimal_places",
          required: true,
          order: 3,
          options: [
            {
              label: "1",
              value: 0,
              isStaticValue: true,
            },
            {
              label: "1.0",
              value: 1,
              isStaticValue: true,
            },
            {
              label: "1.00",
              value: 2,
              isStaticValue: true,
            },
            {
              label: "1.000",
              value: 3,
              isStaticValue: true,
            },
            {
              label: "1.0000",
              value: 4,
              isStaticValue: true,
            },
          ],
          defaultOption: 0,
        },
        {
          name: "calculation",
          type: "textarea",
          label: "calculation",
          required: true,
          order: 4,
        },
      ],
    },
  ],
  gps: [
    {
      name: "field_label",
      type: "textarea",
      label: "field_label",
      required: true,
      order: 1,
      defaultValue: "",
    },
    {
      name: "field_code",
      type: "text",
      label: "field_code",
      required: true,
      order: 2,
      defaultValue: "gps_",
    },
    {
      name: "view_options",
      type: "selection",
      label: "view_options",
      required: true,
      order: 3,
      options: [
        {
          label: "form_templates.template_structure.gps.small_map",
          value: "small_map",
        },
        {
          label: "form_templates.template_structure.gps.large_map",
          value: "large_map",
        },
        {
          label: "form_templates.template_structure.gps.lat_long",
          value: "lat_long",
        },
        {
          label: "form_templates.template_structure.gps.map_link",
          value: "map_link",
        },
      ],
      defaultOption: "small_map",
    },
    {
      name: "required",
      type: "checkbox",
      label: "required",
      required: true,
      order: 4,
      defaultValue: false,
    },
    {
      name: "hidden",
      type: "checkbox",
      label: "hidden",
      required: true,
      order: 5,
      defaultValue: false,
    },
  ],
  slider: [
    {
      name: "field_label",
      type: "textarea",
      label: "field_label",
      required: true,
      order: 1,
      defaultValue: "",
    },
    {
      name: "field_code",
      type: "text",
      label: "field_code",
      required: true,
      order: 2,
      defaultValue: "slider_",
    },
    {
      name: "default_value",
      type: "text",
      label: "default_value",
      required: true,
      order: 3,
      defaultValue: "",
    },
    {
      name: "min_value",
      type: "number",
      label: "min_value",
      required: true,
      order: 4,
      defaultValue: null,
    },
    {
      name: "max_value",
      type: "number",
      label: "max_value",
      required: true,
      order: 5,
      defaultValue: null,
    },
    {
      name: "required",
      type: "checkbox",
      label: "required",
      required: true,
      order: 6,
      defaultValue: false,
    },
    {
      name: "read_only",
      type: "checkbox",
      label: "read_only",
      required: true,
      order: 7,
      defaultValue: false,
    },
  ],
  rating: [
    {
      name: "field_label",
      type: "textarea",
      label: "field_label",
      required: true,
      order: 1,
      defaultValue: "",
    },
    {
      name: "field_code",
      type: "text",
      label: "field_code",
      required: true,
      order: 2,
      defaultValue: "rating_",
    },
    {
      name: "default_value",
      type: "text",
      label: "default_value",
      required: true,
      order: 3,
      defaultValue: "",
    },
    {
      name: "min_value",
      type: "number",
      label: "min_value",
      required: true,
      order: 4,
      defaultValue: null,
    },
    {
      name: "max_value",
      type: "number",
      label: "max_value",
      required: true,
      order: 5,
      defaultValue: null,
    },
    {
      name: "required",
      type: "checkbox",
      label: "required",
      required: true,
      order: 6,
      defaultValue: false,
    },
    {
      name: "read_only",
      type: "checkbox",
      label: "read_only",
      required: true,
      order: 7,
      defaultValue: false,
    },
  ],
  barcode: [
    {
      name: "field_label",
      type: "textarea",
      label: "field_label",
      required: true,
      order: 1,
      defaultValue: "",
    },
    {
      name: "field_code",
      type: "text",
      label: "field_code",
      required: true,
      order: 2,
      defaultValue: "barcode_",
    },
    {
      name: "required",
      type: "checkbox",
      label: "required",
      required: true,
      order: 3,
      defaultValue: false,
    },
  ],
};

export default formFields;
